import 'tailwindcss/tailwind.css';
import React, { useState, useEffect } from 'react';
import './styles.css'; // Import your CSS file
import { ThemeProvider } from "@material-tailwind/react";

import NavbarWithMegaMenu from './common/components/menus/NavbarWithMegaMenu';
import { ActiveTabProvider, useActiveTab } from './common/ActiveTabContext';
import { LogicAppTabProvider, useLogicAppTab } from './services/LogicApp/LogicAppTabContext';

import ChatComponent from './services/GPT/ChatComponent';
import JamieComponent from './services/Whisper/JamieComponent';
import JobHistoryComponent from './common/components/JobHistoryComponent';
import UpgradePage from './pages/IntroPage/UpgradePage';
import { getQueuedJob, resetQueuedJob } from './common/nip105-client';
import PaymentChoiceComponent from './common/components/paymentChoiceComponent';

import IntroPageQ42024 from './pages/IntroPage/IntroPageQ42024';

const oldUI = false;

function getInitialTabFromQueryString() {
  const params = new URLSearchParams(window.location.search);
  const tab = params.get('tab');
  const wfid = params.get('wfid'); // Extract wfid from the query string
  return { tab: tab ? tab : null, wfid: wfid ? wfid : null }; // Return both tab and wfid
}

const App = ({ wfid }) => {

  const { activeTab,setActiveTab } = useActiveTab();
  const [paymentChoiceStatus, setPaymentChoiceStatus] = useState(null);

  useEffect(() => {
    const handlePopState = () => {
      const params = new URLSearchParams(window.location.search);
      const tab = params.get('tab');
      setActiveTab(tab ? tab : null);
    };
  
    window.addEventListener('popstate', handlePopState);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return () => window.removeEventListener('popstate', handlePopState);
  }, [setActiveTab]);

  return (
    <div className="App" style={{backgroundColor: 'black'}}>
      {activeTab !== null ? (
        <div>
          <PaymentChoiceComponent paymentChoiceStatus={paymentChoiceStatus} setPaymentChoiceStatus={setPaymentChoiceStatus} />
          <NavbarWithMegaMenu paymentChoiceStatus={paymentChoiceStatus} setPaymentChoiceStatus={setPaymentChoiceStatus} />
          {activeTab === "GPT" && <ChatComponent paymentChoiceStatus={paymentChoiceStatus} setPaymentChoiceStatus={setPaymentChoiceStatus} />}
          {(activeTab === "jamie" || activeTab === "whisper") && <JamieComponent paymentChoiceStatus={paymentChoiceStatus} setPaymentChoiceStatus={setPaymentChoiceStatus}/>}
          {activeTab === "upgrade" && <UpgradePage />}
          {activeTab === "history" && <JobHistoryComponent paymentChoiceStatus={paymentChoiceStatus} setPaymentChoiceStatus={setPaymentChoiceStatus}/>}
        </div>
      ) : (
        <IntroPageQ42024 />
      )}
    </div>
  );
};

const RootApp = () => {
  const { tab, wfid } = getInitialTabFromQueryString(); // Destructure to get tab and wfid

  return (
    <ThemeProvider>
      <LogicAppTabProvider>
        <ActiveTabProvider initialActiveTab={tab}>
          <App wfid={wfid} />
        </ActiveTabProvider>
      </LogicAppTabProvider>
    </ThemeProvider>
  );
};


export default RootApp;
